import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  loadInitialAuthenticationStateAsync,
  selectAuthInitializationStatus,
} from "../../features/authentication/authenticationSlice";
import {
  detectAndUpdateTimezone,
  initializeI18n,
} from "../../features/localization/localizationSlice";

interface InitializeAuthProps {
  children: React.ReactNode;
}

const InitializeAuth = ({ children }: InitializeAuthProps) => {
  const dispatch = useAppDispatch();
  const initializationStatus = useAppSelector(selectAuthInitializationStatus);
  const bypassAuth = import.meta.env.VITE_BYPASS_AUTH === 'true' && import.meta.env.VITE_DEBUG_MODE === 'true';

  useEffect(() => {
    if (bypassAuth) {
      // In bypass mode, just initialize localization without auth
      dispatch(initializeI18n());
      dispatch(detectAndUpdateTimezone());
      return;
    }

    if (initializationStatus === "not-initialized") {
      dispatch(loadInitialAuthenticationStateAsync());
    }
  }, [dispatch, initializationStatus, bypassAuth]);

  useEffect(() => {
    if (!bypassAuth && initializationStatus === "initialized") {
      dispatch(initializeI18n());
      dispatch(detectAndUpdateTimezone());
    }
  }, [dispatch, initializationStatus, bypassAuth]);

  return <>{children}</>;
};

export default InitializeAuth;
